var map = {
	"./AmiyaBagchi.jpg": 598,
	"./AmiyaBagchi.png": 599,
	"./ChinmayTumbe.png": 600,
	"./DavidArnold.jpg": 601,
	"./DavidArnold.png": 602,
	"./DouglasHaynes.jpg": 603,
	"./DouglasHaynes.png": 604,
	"./DwijendraTripathi.jpg": 605,
	"./DwijendraTripathi.png": 606,
	"./GeoffreyJones.png": 607,
	"./IndiraChowdhury.jpg": 608,
	"./IndiraChowdhury.png": 609,
	"./JosephSassoon.jpg": 610,
	"./JosephSassoon.png": 611,
	"./MedhaKudaisya.jpg": 612,
	"./MedhaKudaisya.png": 613,
	"./PrafullAnubhai.jpg": 614,
	"./PrafullAnubhai.png": 615,
	"./RamachandraGuha.png": 616,
	"./RituBirla.jpg": 617,
	"./RituBirla.png": 618,
	"./RobertPerks.png": 619,
	"./RossBassett.jpg": 620,
	"./RossBassett.png": 621,
	"./SvenBeckert.png": 622,
	"./SvenBeckertOld.png": 623,
	"./TirthankarRoy.jpg": 624,
	"./TirthankarRoy.png": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 597;